import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import dataRetention from '../assets/data/dataRetention';

const KeyFeatures = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 }); // Smoothed animation duration slightly for production feel
    }, []);
    
    return (
        /* Section wrapper updated to matching deep black canvas background from Screenshot 2026-06-16 at 3.33.16 PM.png */
        <div className='bg-black lg:pl-20 p-10 lg:pr-20 2xl:pr-60 2xl:pl-60' data-aos="fade-up" data-aos-offset="50">
            <div className='bg-transparent rounded-3xl p-10 lg:pt-6 2xl:pt-14 xl:pt-10 md:w-full md:h-full flex-wrap lg:w-full lg:h-auto h-auto w-full xl:pl-10 xl:pr-10 lg:pl-16 lg:pr-16 lg:pb-16'>
                
                {/* Section Title updated to crisp white text layout alignment */}
                <h3 className='text-white text-3xl md:text-[54px] leading-tight font-bold text-left mb-10 tracking-tight max-w-xl'>
                    Data Retention Key Features
                </h3>
                
                {/* Features Grid Frame */}
                <div className='grid md:grid-cols-2 grid-cols-1 pt-4 lg:grid-cols-3 2xl:pt-8 2xl:gap-14 gap-6'>
                    {dataRetention.map((item, index) => (
                        <div 
                            key={index} 
                            /* 
                              Cards updated to brand green background theme (bg-bgColor).
                              Borders dropped to match flat aesthetic layout.
                            */
                            className='lg:w-full w-auto md:w-mBoxes bg-bgColor flex flex-col gap-4 p-8 lg:pl-8 lg:pr-8 lg:pt-8 2xl:pt-8 lg:h-auto min-h-[320px] rounded-[28px] shadow-sm'
                            data-aos={index % 2 === 0 ? "fade-down" : "fade-right"} 
                        >
                            {/* Feature Icon Asset */}
                            {item.img && (
                                <img 
                                    src={item.img} color='white'
                                    alt={item.title} 
                                        className='lg:h-12 lg:w-12 w-10 h-10 object-contain invert brightness-0' 
                                />
                            )}
                            
                            {/* Card Content inverted to deep dark tones over the green cards */}
                            <h3 className='font-bold text-[#fff] text-2xl tracking-tight'>
                                {item.title}
                            </h3>
                            
                            <p className='text-sm text-[#fff]/90 leading-relaxed font-medium'>
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KeyFeatures;